import { Grid, withStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Close from '@material-ui/icons/Close';
import * as React from 'react';

export interface IRecentSearchProps {
  classes: any;
  className?: any;
  variant?: any;
  label: string;
  onClick(searchText: string): void;
  onClose?: any;
}

export interface IRecentSearchState {
  displayRecentSearch: boolean;
}

class RecentSearch extends React.Component<IRecentSearchProps, IRecentSearchState> {
  constructor(props: IRecentSearchProps) {
    super(props);

    this.state = {
      displayRecentSearch: true,
    };
  }

  handleClose = () => {
    this.props.onClose ? this.props.onClose(this.props.label) : this.setState({ displayRecentSearch: false });
  };

  displayChip = () => {
    const { classes } = this.props;
    if (this.state.displayRecentSearch) {
      return (
        <Grid item className={classes.chipGrid} xs={4}>
          <Chip
            label={this.props.label}
            onDelete={() => this.handleClose()}
            onClick={() => this.props.onClick(this.props.label)}
            variant="outlined"
            className={classes.root}
            deleteIcon={<Close className={classes.close} />}
          />
        </Grid>
      );
    } else {
      return <div></div>;
    }
  };

  public render() {
    const { classes } = this.props;
    return this.displayChip();
  }
}

export default withStyles((style) => ({
  root: {
    height: '26px',
    minWidth: '128px',
    maxWidth: '200px',
    width: 'auto',
    backgroundColor: '#EDEDED',
    borderRadius: '18px',
    // boxShadow: "2px 2px 4px 2px rgba(0,0,0,0.1)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2px 4px',
    // marginRight: "8px",
    border: 0,
    color: '#1C1E20',
  },
  chipGrid: {
    minWidth: 140,
    width: 'auto',
    maxWidth: 212,
    height: 34,
  },
  close: {
    color: '#535353',
    height: 16,
    width: 16,
  },
}))(RecentSearch);
